import React from 'react';
import { Link } from 'react-router-dom';
import { checkMot } from '../../../ressources/functionJS/checkMot';
import S from './Widget.module.scss';
import pin from '../../../ressources/accueil/fOn.png';

const WidgetProjets = ({ projects = [], favoriteProjectIds = [] }) => {
  // Filtrer les projets favoris
  const favoriteProjects = projects
    .filter((p) => favoriteProjectIds.includes(p.project_id))
    .slice(0, 5);

  const hasProjects = favoriteProjects && favoriteProjects.length > 0;

  return (
    <div className={[S.widget, S.widgetSmall].join(' ')}>
      <div className={S.dashboardWidgetHeader}>
        <h3 className={S.dashboardWidgetTitle}>{checkMot('mes_projets')}</h3>
      </div>
      <div className={S.widgetContent}>
        {hasProjects ? (
          <ul className={S.projectList}>
            {favoriteProjects.map((project) => (
              <li key={project.project_id} className={S.projectItem}>
                <span className={S.projectIcon}>
                  <img src={pin} alt="Favori" />
                </span>
                <Link to={`/${project.project_id}`} className={S.projectLink}>
                  {project.project_name}
                </Link>
              </li>
            ))}
          </ul>
        ) : (
          <div className={S.emptyState}>
            <p className={S.emptyText}>{checkMot('aucun_projet_favori')}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default WidgetProjets;
